import styled, { css } from 'styled-components'
// components
import MuiInput, { InputProps } from '@mui/material/Input'
// themes
import { colors } from 'themes/index'

export const IconButton = styled.div`
  color: rgba(0, 0, 0, 0.54);
  cursor: pointer;
`

interface InputCustomProps {
  inputColor?: string
  withEllipsis?: boolean
  showAdornment?: boolean
}

export const Input = styled(({ disabled, readOnly, inputColor, withEllipsis, showAdornment, ...props }) => (
  <MuiInput disabled={disabled} readOnly={readOnly} {...props} />
))<InputProps & InputCustomProps>`
  && {
    > input {
      ${({ inputColor }) => inputColor && `color: ${inputColor};`};

      ${({ readOnly }) =>
        readOnly &&
        css`
          color: ${colors.blue500};
          cursor: pointer;
          font-weight: bold;
        `};

      ${({ withEllipsis }) =>
        withEllipsis &&
        css`
          max-width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        `};
    }

    p {
      display: ${({ showAdornment }) => (showAdornment ? 'unset' : 'none')};
    }
  }
`
